import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as idcFunctions from '../../../../idc-functions'
import * as _function from '../function'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: _function.RESOURCE.payload.dimension.partialId,
      partialId: _function.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'IDC Function',
    isOptional: true,
    name: 'IDC Function',
    partialId: PartialId.Standard.create('func_idc'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        idcFunctions.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
